
import React from "react";
import styles from "./Presentation.module.css";
import ForceComponent from "../Force/ForceComponent";
import { PresentationTypes } from "@/types/displayData/PresentationTypes";

const PresentationComponent: React.FC<PresentationTypes> = ({hero, features}) => {
  return (
    <div className="relative">
      <section className={styles.presentationSection}>
        <img
          src="/assets/images/cheptel.png"
          alt="Cheptel"
          className={styles.presentationImage}
          loading="eager"
        />
        <div className={styles.presentationOverlay}>
          <div className={styles.presentationContent}>
            <h1 className={styles.presentationTitle}>{hero.title}</h1>
            <p className={styles.presentationDescription}>{hero.description}</p>
          </div>
        </div>
      </section>

      <div className={styles.overlapSection}>
        <ForceComponent features={features} />
      </div>
    </div>
  );
};

export default PresentationComponent;
